// Название cookie для переопределния hostname для магазина
export const YAKIT_FORCE_SET_HOSTNAME_COOKIE_NAME = 'yakit_force_set_hostname';

/** Имя passport-куки сессии (см. passport/backend/core/cookies/consts.py) */
export const SESSION_ID_COOKIE_NAME = 'Session_id';
